import PropTypes from 'prop-types';
import Wrapper from '../common/Wrapper/Wrapper';
import CategoryBox from '../CategoryBox/CategoryBox';
import { StyledCategoryNav, StyledCategoryMenu } from './CategoryNav.styles';

function CategoryNav({ categories, query, company }) {
  const filteredArray = categories.filter(item =>
    item.title.toLowerCase().includes(query.toLowerCase())
  );

  if (!categories.length) return null;

  return (
    <StyledCategoryNav>
      <Wrapper>
        <StyledCategoryMenu>
          {company && <CategoryBox data={company} />}
          {filteredArray.map(item => (
            <CategoryBox key={item.id} data={item} />
          ))}
        </StyledCategoryMenu>
      </Wrapper>
    </StyledCategoryNav>
  );
}

CategoryNav.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      url: PropTypes.string,
      photo: PropTypes.string,
      title: PropTypes.string.isRequired,
      color: PropTypes.string,
      item: PropTypes.string,
      alt: PropTypes.string,
    })
  ),
  query: PropTypes.string,
};

CategoryNav.defaultProps = {
  categories: [],
  query: '',
};

export default CategoryNav;
